import { requestYfd } from './request'

// 获取候选人信息
export function getCandidateInfo(authCode) {
  return requestYfd(
    `/ep-garden-user-feedback/api/back_ground/feedback/${authCode}/candidate_plain`,
  )
}

// 保存背调填写信息
export function saveBackInfo(authCode, body) {
  return requestYfd(
    `/ep-garden-user-feedback/api/back_ground/feedback/${authCode}/candidate_plain`,
    {
      method: 'post',
      body,
    },
  )
}
